import React from "react";

export default function HeartLine({ className = "" }) {
  return (
    <div className={`heartLine ${className}`}>
      <span className="heart">❤</span>
    </div>
  );
}
